//
import { AxiosRequestConfig } from "axios";

//
import Network      from "./Network";
import Validator    from "@common/utils/Validator";




//
//
//
export class RestfulEndpoint
{
    public method           : Network.Method = Network.Method.GET; 
    public url              : string = "";        // /session/login/:id
    public timeout          : number | null;
    public headers          : any;
    public body             : any;

    //
    // request
    //
    public request          : any = null;

    ////////////////////////////////////////////////////////////////////////////////////////////
    constructor(    method   : Network.Method,
                    url      : string,
                    timeout  : number | null = null )
    {
        this.method          = method;
        this.url             = url;
        this.timeout         = timeout;
        this.reset();
    }

    /////////////////////////////////////////////////////////////////////////////////////////////
    public dump() : void
    {
        console.log({method:this.method, url:this.url });
    }

    /////////////////////////////////////////////////////////////////////////////////////////////
    public reset() : void
    {
    }

    
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    public validate( request : AxiosRequestConfig ) : RestfulEndpoint.Reply
    {
        if( this.method == Network.Method.GET && Validator.notNull( this.body ) )
        {
            return this.failure( Network.Status.BAD_REQUEST, RestfulEndpoint.Error.MISSING_OR_BAD_DATA, "GET cannot have BODY attributes" );
        }
        else
        {
            //let check : Endpoint.DataCheck = this.validateData( request );
            //if( !check.ok )return this.failure( Network.Status.BAD_REQUEST, Endpoint.Error.MISSING_OR_BAD_DATA, check.message );
        }
        return { status: Network.Status.OK };
    }

    ////////////////////////////////////////////////////////////////////////////
    public errorCode( code: string ) : string
    {
        return code;
    }

    //////////////////////////////////////////////////////////////////////////////////
    public failure( status: Network.Status, code: string, message? : string ) : RestfulEndpoint.Reply
    {
        return { status: status, data: { code: code, message: message } };
    }
}


//}

//
//
export namespace RestfulEndpoint
{

    //
    // standard set that can be selected from but it can be extended with unique ones
    //
    export enum Error
    {
        NOT_IMPLEMENTED     = "not_implemented",
        MISSING_OR_BAD_DATA = "missing_or_bad_data",
        INVALID_IDENTIFIER  = "invalid_identifier",
        NOT_AUTHORIZED      = "not_authorized",
        NOT_FOUND           = "not_found",
        DELETED             = "deleted",
    }

    export interface ErrorReply
    {
        code   : string;
        message? : string;
    }

    export interface Reply
    {
        status : Network.Status;
        data?  : any | ErrorReply;
    }


}

//
// eof
//